import { render, staticRenderFns } from "./informationCheckComponent.vue?vue&type=template&id=9be3bc32&"
import script from "./informationCheckComponent.vue?vue&type=script&lang=js&"
export * from "./informationCheckComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports